"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schema = void 0;
const schema = exports.schema = {
  type: "object",
  properties: {
    phoneNumber: {
      type: "string",
      pattern: "^[+]?[0-9]*$",
      minLength: 13
    }
  },
  required: ["phoneNumber"]
};